import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('submit', '[data-checkout-notification-form]', function(event) {
  event.preventDefault();
  const $form = $(this);
  ['Media', 'Number', 'Contact', 'DeliveryDate', 'DeliveryFrom', 'DeliveryTo'].forEach((field) => {
    const val = $form.find(`[name="custom_Notification_${field}"]`).val();
    $(`[type="hidden"][name="custom_Notification_${field}"]`).val(val);
  });
  $form.removeAttr('data-checkout-confirm-messages');
  $('[data-checkout-form]').submit();
});

$(document).on('open.zf.reveal', '#checkout-shippingdate-edit', () => {
  if (document.documentMode || $('#id_shipping_date').get(0).type === 'text') {
    $('#id_shipping_date').val($('#checkout-shippingdate-text').text());
  } else {
    $('#id_shipping_date').val($('#checkout-shippingdate-value').val());
  }
});

$(document).on('submit', '#checkout-shippingdate-edit', (event) => {
  event.preventDefault();

  if (document.documentMode || $('#id_shipping_date').get(0).type === 'text') {
    $('#checkout-shippingdate-value').val($('#id_shipping_date').val());
    $('#checkout-shippingdate-text').text($('#id_shipping_date').val());
  } else {
    const shippingdate = $('#id_shipping_date').val().split('-');
    $('#checkout-shippingdate-text').text(`${shippingdate[2]}.${shippingdate[1]}.${shippingdate[0]}`);
    $('#checkout-shippingdate-value').val($('#id_shipping_date').val());
  }

  $('#checkout-shippingdate-value').closest('table').find('tbody > tr').each(function() {
    if ($(this).find('input[type="radio"]:checked').length) {
      const radios = $(this).find('input[type="radio"]');
      if (radios.length === 2) {
        if (radios.first().is(':checked')) {
          radios.get(1).checked = true;
        }
      } else {
        const radio = $(this).closest('tbody').find('tr td:nth-child(3) input[type="radio"]').first();
        radio.first().get(0).checked = true;
      }
    }
  });

  $('#checkout-shippingdate-edit').foundation('close');
  $('[data-checkout-shippingdate-field]').trigger('change');
});

$(document).on('change', 'tr.shipping-method input[type="radio"]', function() {
  $('.shipping-method--active').removeClass('shipping-method--active');
  if ($(this).is(':checked')) {
    $(this).closest('tr').find('td:first, input + span').addClass('shipping-method--active');
  }
});

$(document).on('change', '[data-calc-compensation] input[type="checkbox"]', function() {
  const $form = $(this).closest('form');
  $form.closest('.widget').addClass('loading');
  $.stores.checkout.load($form.attr('action'), $form.serializeArray());
});

$(document).on('change', '[data-checkout-update-form-on-change]', function () {
  const $form = $(this);
  const $widget = $form.closest('[data-checkout-step]');
  load(
    $widget,
    $.stores.checkout.load($form.attr('action'), new FormData(this)),
  );
  this.disabled = true;
});
